var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMinus = function SvgMinus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.864 13.454a.58.58 0 0 1-.495-.186.58.58 0 0 1-.186-.495v-1.546a.58.58 0 0 1 .186-.495.58.58 0 0 1 .495-.186h16.272q.278-.03.495.186t.186.495v1.546a.58.58 0 0 1-.186.495.58.58 0 0 1-.495.186z"
  })));
};
export default SvgMinus;